var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseGridLayout',{attrs:{"size":"small"}},[_c('section',{staticClass:"col-span-full flex justify-center"},[(!!_vm.cta && _vm.remoteDatasetLoaded)?_c('BaseCta',{staticClass:"mt-5",attrs:{"id":_vm.anchorName,"link":_vm.cta}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }